import parse, { domToReact } from "html-react-parser";
import React from "react";

export function createGoogleMapsLink(address: string): string {
  const encodedAddress = encodeURIComponent(address);
  return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
}

export const logError = (message: string, error: any): void => {
  if (process.env.NODE_ENV === "development") {
    console.error(message, error);
  }
};

export function formatKeyLabel(key: string): string {
  return key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

export function appendHTTPS(url: string): string {
  if (!url.startsWith("http")) {
    return `https://${url}`;
  }
  return url;
}

function extractTextFromNode(node: any): string {
  if (!node) return "";
  if (node.type === "text") {
    return node.data || "";
  }
  if (node.type === "tag" && node.children) {
    return node.children
      .map((child: any) => extractTextFromNode(child))
      .join("")
      .trim();
  }
  return "";
}

export function createLinkParser(handleRedirect: any, history: any, pageName: string = "RECO_ENGINE") {
  return (html: string | undefined) => {
    if (!html || typeof html !== "string") {
      return html;
    }
    
    if (html.includes(".") && !html.includes("<")) {
      return html;
    }
    
    const replaceNode = (domNode: any) => {
      if (domNode.type === "tag" && domNode.name === "a") {
        const href = domNode.attribs?.href;
        
        if (href) {
          const linkText = extractTextFromNode(domNode) || href;
          const linkContent = domNode.children ? domToReact(domNode.children) : linkText;
          
          // Use URL type for tel: and mailto: links to allow native handling
          const isProtocolLink = href.startsWith("tel:") || href.startsWith("mailto:");
          const buttonAction = isProtocolLink
            ? {
                type: "URL" as const,
                url: href,
              }
            : {
                type: "IN_APP_BROWSER" as const,
                url: href,
                hideToolBar: true,
                traverseWebHistoryOnBackPressed: true,
              };
          
          return (
            <button
              key={href}
              type="button"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                handleRedirect(
                  buttonAction,
                  history,
                  isProtocolLink ? "" : linkText,
                  pageName
                );
              }}
              className="inline-link-button"
              aria-label={isProtocolLink ? `Open ${linkText}` : `Open ${linkText} in app browser`}
            >
              {linkContent}
            </button>
          );
        }
      }
      return undefined;
    };
    
    return parse(html, { replace: replaceNode });
  };
}
